import { render, staticRenderFns } from "./SubscriptionsDialog.vue?vue&type=template&id=0cf6c13c&scoped=true&"
import script from "./SubscriptionsDialog.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionsDialog.vue?vue&type=style&index=0&id=0cf6c13c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf6c13c",
  null
  
)

export default component.exports